module.exports = __webpack_public_path__ + "./docs/img/icon-const.b289a5ef98456b936f62aec83acdf91e.svg";